// extracted by mini-css-extract-plugin
export default {"MenuWrapper":"Menu_MenuWrapper__GE6wI","MenuHidden":"Menu_MenuHidden__QCp86"};